import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { RootState, ReportsState } from "@/types/store";
import { createReport, getHomeownerReports } from "@/api/report/thunks";

const ITEMS_PER_PAGE = 10;

const initialState: ReportsState = {
  reports: [],
  loading: false,
  error: null,
  totalPages: 0,
  currentPage: 1,
  total: 0,
};

export const reportsSlice = createSlice({
  name: "ReportsSlice",
  initialState,
  reducers: {
    clearReports: (state) => {
      state.reports = [];
      state.error = null;
    },
    clearErrors: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createReport.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(getHomeownerReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHomeownerReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload.reports || [];
        const totalPages = Math.ceil(
          (Number(action.payload.total) || 0) / ITEMS_PER_PAGE
        );
        state.totalPages = totalPages;
        state.currentPage = action.payload.page || 1;
        state.total = action.payload.total || 0;
      })
      .addCase(getHomeownerReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearReports, clearErrors } = reportsSlice.actions;

export default reportsSlice.reducer;

export const useReportsData = () => {
  const reports = useSelector((state: RootState) => state.Reports.reports);
  const loading = useSelector((state: RootState) => state.Reports.loading);
  const error = useSelector((state: RootState) => state.Reports.error);
  const totalPages = useSelector(
    (state: RootState) => state.Reports.totalPages
  );
  const currentPage = useSelector(
    (state: RootState) => state.Reports.currentPage
  );
  const total = useSelector((state: RootState) => state.Reports.total);

  return {
    reports,
    loading,
    error,
    totalPages,
    currentPage,
    total,
  };
};
